import moment from 'moment-timezone'

const clockText = value => typeof value === 'string' ? value : value?.match || ''

export const gameStatus = game => {
  if (game.isComplete) return game.isOT ? 'Final · OT' : 'Final'
  if (/postpon|delay|cancel|suspend|half/i.test(game.scoreType || '')) return game.scoreType
  if (game.isInProgress) return [clockText(game.gameQuarter), clockText(game.gameClock)].filter(Boolean).join(' · ') || game.scoreType || 'Live'
  return game.date && moment(game.date).isValid() ? moment(game.date).format('h:mm A') : 'Time TBD'
}

export const teamScore = (scoreboard, team) => {
  const side = [1, 2].find(index => String(scoreboard?.[`_id${index}`]) === String(team?._id))
  return side ? { score: scoreboard[`score${side}`], record: scoreboard[`record${side}`], chance: scoreboard[`cow${side}`] } : {}
}

// Only display picks supplied by the API for a team it explicitly allows us to show.
export const pickDetails = (game, team, visible) => {
  if (!visible) return { text: 'Picks hidden', tone: 'neutral' }
  const favorite = (game.favoritePicks || []).find(pick => String(pick.teamId) === String(team?._id))
  const underdog = (game.underdogPicks || []).find(pick => String(pick.teamId) === String(team?._id))
  const pick = favorite || underdog
  if (!pick) return { text: 'No pick available', tone: 'neutral' }
  const abbreviation = favorite ? game.favoriteAbbrev : game.underdogAbbrev
  let outcome = ''
  let tone = game.isInProgress ? 'neutral' : 'pregame'
  if (game.result === 'Push') { outcome = 'Push'; tone = 'neutral' }
  else if ((game.isInProgress || game.isComplete) && game.result && typeof pick.isPickCorrect === 'boolean') {
    outcome = game.isComplete ? (pick.isPickCorrect ? 'Correct' : 'Incorrect') : (pick.isPickCorrect ? 'Leading' : 'Trailing')
    tone = `${game.isComplete ? 'final' : 'live'}${pick.isPickCorrect ? 'Success' : 'Danger'}`
  }
  return { rank: pick.rank, side: favorite ? 'favorite' : 'underdog', text: `${(abbreviation || '').toUpperCase()} · ${pick.rank} ${pick.rank === 1 ? 'pt' : 'pts'}`, outcome, tone }
}
